import { useEffect } from 'react';
import packageJson from '../../package.json';

const VersionChecker = () => {
  useEffect(() => {
    const currentVersion = packageJson.version;
    const storedVersion = localStorage.getItem('app-version');
    
    // 如果版本不同，清除缓存并刷新
    if (storedVersion && storedVersion !== currentVersion) {
      console.log(`版本已更新: ${storedVersion} -> ${currentVersion}`);
      localStorage.setItem('app-version', currentVersion);
      
      // 清除所有缓存
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }
      
      // 强制刷新页面
      window.location.reload(true);
    } else {
      // 存储当前版本
      localStorage.setItem('app-version', currentVersion);
    }
    
    // 定期检查版本更新（每5分钟）
    const checkInterval = setInterval(() => {
      fetch('/api/version', { cache: 'no-cache' })
        .then(res => res.json())
        .then(data => {
          if (data.version && data.version !== currentVersion) {
            console.log(`检测到新版本: ${data.version}`);
            localStorage.setItem('app-version', data.version);
            window.location.reload(true);
          }
        })
        .catch(err => console.error('版本检查失败:', err));
    }, 5 * 60 * 1000); // 5分钟
    
    return () => clearInterval(checkInterval);
  }, []);
  
  return null;
};

export default VersionChecker; 